import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ServiceDetailPage.css';

const SociosanitariosPage = () => {
  const subServices = [
    {
      title: 'Atención en Centros de Salud',
      description: 'Personal especializado para clínicas, hospitales y centros médicos.',
      features: [
        'Auxiliares de enfermería',
        'Técnicos en farmacia',
        'Personal de laboratorio',
        'Celadores y camilleros',
        'Atención de emergencias'
      ]
    },
    {
      title: 'Cuidado de Personas Mayores',
      description: 'Servicios de atención y acompañamiento para adultos mayores.',
      features: [
        'Cuidado personalizado en residencias',
        'Atención domiciliaria',
        'Apoyo en actividades diarias',
        'Acompañamiento médico',
        'Terapia ocupacional'
      ]
    },
    {
      title: 'Atención a Personas con Discapacidad',
      description: 'Servicios especializados de apoyo y cuidado integral.',
      features: [
        'Atención personalizada',
        'Terapias de rehabilitación',
        'Apoyo en integración social',
        'Cuidado en centros especializados',
        'Acompañamiento familiar'
      ]
    },
    {
      title: 'Servicios de Limpieza Sanitaria',
      description: 'Limpieza especializada con protocolos certificados de bioseguridad.',
      features: [
        'Desinfección de áreas críticas',
        'Manejo de residuos hospitalarios',
        'Protocolos de bioseguridad',
        'Personal capacitado en normativas',
        'Equipos especializados'
      ]
    },
    {
      title: 'Gestión de Servicios Hospitalarios',
      description: 'Administración integral de servicios no médicos en centros de salud.',
      features: [
        'Gestión de servicios auxiliares',
        'Logística hospitalaria',
        'Mantenimiento de instalaciones',
        'Gestión de lavandería',
        'Servicios de alimentación'
      ]
    },
    {
      title: 'Formación y Capacitación',
      description: 'Programas de formación para personal sociosanitario.',
      features: [
        'Capacitación en protocolos',
        'Actualización normativa',
        'Primeros auxilios',
        'Atención al paciente',
        'Bioseguridad y prevención'
      ]
    }
  ];

  return (
    <div className="service-detail-page">
      <section className="service-hero">
        <div className="service-hero-content">
          <h1>Servicios Sociosanitarios</h1>
          <p>Atención especializada con calidad humana y profesionalismo</p>
        </div>
      </section>

      <section className="service-intro">
        <div className="container">
          <div className="intro-content">
            <div className="intro-text">
              <h2>Compromiso con el Cuidado y la Salud</h2>
              <p>
                Nuestros servicios sociosanitarios están diseñados para brindar atención de calidad 
                en entornos de salud y cuidado, combinando profesionalismo técnico con calidez humana.
              </p>
              <p>
                Contamos con personal altamente capacitado, certificado y con vocación de servicio, 
                comprometido con el bienestar de las personas bajo su cuidado.
              </p>
            </div>
            <div className="intro-image">
              <img 
                src="/images/sociosanitarios-principal.jpg" 
                alt="Servicios Sociosanitarios"
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 400"%3E%3Crect fill="%230D3B66" width="500" height="400"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="white" font-size="80"%3E🏥%3C/text%3E%3C/svg%3E';
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="sub-services">
        <div className="container">
          <h2>Nuestros Servicios Sociosanitarios</h2>
          <div className="sub-services-grid">
            {subServices.map((service, index) => (
              <div key={index} className="sub-service-card">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul>
                  {service.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="service-benefits">
        <div className="container">
          <h2>¿Por Qué Confiar en Nosotros?</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">❤️</div>
              <h3>Vocación de Servicio</h3>
              <p>Personal comprometido con el cuidado</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">🎓</div>
              <h3>Formación Continua</h3>
              <p>Capacitación permanente del equipo</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">🛡️</div>
              <h3>Protocolos Certificados</h3>
              <p>Cumplimiento normativo sanitario</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">👨‍⚕️</div>
              <h3>Experiencia Especializada</h3>
              <p>Años de trayectoria en el sector</p>
            </div>
          </div>
        </div>
      </section>

      <section className="service-cta">
        <div className="container">
          <h2>¿Necesita servicios sociosanitarios?</h2>
          <p>Contáctenos y diseñemos la solución ideal para su centro</p>
          <div className="cta-buttons">
            <Link to="/contacto" className="btn-primary">Solicitar Cotización</Link>
            <Link to="/servicios" className="btn-secondary">Ver Todos los Servicios</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SociosanitariosPage;
